import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
type PageTitleProps = React.PropsWithChildren<{
  Icon?: React.ElementType;
  className?: string;
}>;
export default function PageTitle(t0) {
  const $ = _c(10);
  const {
    children,
    className,
    Icon
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("bg-teal-700 mb-4 py-4 text-center text-white dark:bg-slate-800", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Icon) {
    t2 = Icon && <Icon className="mx-auto mb-2 h-10 w-10" />;
    $[2] = Icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <h1 className="container text-2xl sm:text-3xl">{children}</h1>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}